<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4,6C4.28,6,4.53,5.89,4.71,5.71C4.71,5.71,7,3.41,7,3.41C7,3.41,7,11,7,11C7,11.55,7.45,12,8,12C8.55,12,9,11.55,9,11C9,11,9,3.41,9,3.41C9,3.41,11.29,5.7,11.29,5.7C11.47,5.89,11.72,6,12,6C12.55,6,13,5.55,13,5C13,4.72,12.89,4.47,12.71,4.29C12.71,4.29,8.71,0.29,8.71,0.29C8.53,0.11,8.28,0,8,0C7.72,0,7.47,0.11,7.29,0.29C7.29,0.29,3.29,4.29,3.29,4.29C3.11,4.47,3,4.72,3,5C3,5.55,3.45,6,4,6C4,6,4,6,4,6ZM15,11C14.45,11,14,11.45,14,12C14,12,14,14,14,14C14,14,2,14,2,14C2,14,2,12,2,12C2,11.45,1.55,11,1,11C0.45,11,0,11.45,0,12C0,12,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,12,16,12C16,11.45,15.55,11,15,11C15,11,15,11,15,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Export',
} as DefineComponent
</script>
